import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/financial-product-tables`

export default ({ id }) =>
  http.get(`${api}/${id}`)
